import tracking from '@g4/g4-analytics';
import _ from 'lodash';
import moment from '@g4/moment-utc';
import { tripTypeValues } from '../../utils/constants/trackingConstants';

export const trackErrorEvent = errors => {
  let eventLabels = errors?.map(e => {
    switch (e) {
      case 'SAME_STAY_DEPART_AND_RETURN_DATE_ARE_NOT_ALLOWED': {
        return 'Skip Hotel Same Day Depart & Return';
      }
      case 'STAY_DURATION_MAX_LIMIT_EXCEEDED': {
        return 'Skip Hotel Greater than 30 Days';
      }
      case 'TRAVELERS_MINIMUM_AGE_POLICY_NOT_MET': {
        return 'Skip Hotel Younger Than Minimum Age';
      }
      default:
        return 'Skip Hotel Timeout';
    }
  });

  _.forEach(eventLabels, function(eventLabel) {
    tracking.trackEvent('client_side_error', eventLabel);
  });
};

export const getRawProducts = (
  hotel,
  room,
  operatedBy,
  index,
  flightSearchCriteria,
  partialReservation,
  affinityString
) => {
  const {
    adultsCount,
    childrenCount,
    infantCount,
    lapInfantCount,
    tripType,
    departDate,
    returnDate,
    origin,
    destination,
  } = flightSearchCriteria || {};

  const totalPaxCount =
    adultsCount + childrenCount + infantCount + lapInfantCount;
  const route = origin + destination;
  const bookingDaysOut = moment(departDate?.date).diff(moment(), 'days');
  const item = room ? room : hotel;
  const itemPrice = room
    ? item?.priceBreakdown?.total
    : item?.prices?.packageTotal?.amount;

  // DC-45512: Hotel page: Associate the first promotion with the hotel property for multiple promotion.
  // DC-45512: Hotel details page: Associate the first promotion each room type for multiple promotion.
  const firstPromoLabel = item?.promos?.[0]?.headlineDescription;
  const firstPromoId = item?.promos[0]?.id;

  const mandatoryFeesAmount = room
    ? item?.priceBreakdown?.totalMandatoryFees
    : item?.prices?.totalMandatoryFees;
  return {
    item_id: item?.id,
    item_name: hotel?.name,
    coupon: '',
    discount: '',
    affiliation: 'WWW - Booking',
    index: index,
    item_brand: (operatedBy && operatedBy?.carrier) || 'G4',
    item_category: '3rd Party/Hotels',
    item_category2: hotel?.name,
    item_category3: 'D',
    item_category4: route,
    item_category5: affinityString,
    item_list_id: item?.id,
    price: itemPrice,
    item_variant: `${item?.id}-${item?.name}`,
    quantity: 1,
    item_promotion_name: firstPromoLabel ?? '',
    item_promotion_id: firstPromoId ?? '',
    item_partial_reservation: partialReservation,
    item_loyalty_points_discount: '',
    item_flight_booking_type: tripType,
    item_booking_start: departDate?.date,
    item_booking_end:
      tripType === tripTypeValues.ROUNDTRIP
        ? returnDate?.date
        : departDate?.date,
    item_booking_days_out: bookingDaysOut,
    item_count_child: childrenCount,
    item_count_lap_child: lapInfantCount,
    item_count_infant: infantCount,
    item_count_adult: adultsCount,
    item_count_total: totalPaxCount,
    item_credit_applied: '',
    item_flight_voucher_discount: '',
    item_round_trip_discount: '',
    item_mandatory_fees_required: mandatoryFeesAmount > 0 ? 'Yes' : 'No',
    item_mandatory_fees_amount: mandatoryFeesAmount,
  };
};

export const trackPaginationEvent = page => {
  tracking.trackEvent('site_click_tracking', 'Hotel', 'Page Number |' + page);
};

// Partial hotel stay - when we customized default stay dates
// Returns False if the dates are not customized
// Returns True if the dates are customised
export const isPartialHotelsStay = (
  flightOrderItems,
  checkInDate,
  checkOutDate
) => {
  const isOneWay = flightOrderItems.length === 1;

  if (!isOneWay) {
    const arrivalDate = moment(
      flightOrderItems[0]?.flight.arrivalTime.split('T')[0]
    );
    const departingDate = moment(
      flightOrderItems[1]?.flight.departingTime.split('T')[0]
    );

    return (
      (arrivalDate.diff(moment(checkInDate), 'days') ||
        departingDate.diff(moment(checkOutDate), 'days')) !== 0
    );
  }

  return true;
};

export const getHotelPromoData = (
  index,
  hotel,
  room,
  operatedBy,
  promo,
  affinityString,
  route
) => {
  const item = room ? room : hotel;
  const itemSlot = room ? 'Hotel Details-' : 'Hotel Results-';
  const contentGroup = tracking.getDataLayerVars().content_group;
  return {
    creative: promo?.code,
    name: promo?.headlineDescription,
    position: itemSlot + index + '-' + contentGroup,
    id: promo.id,
    items: [
      {
        item_id: hotel?.id ?? room?.id,
        item_name: hotel?.name ?? room?.name,
        coupon: promo?.code,
        discount: promo?.code,
        affiliation: 'WWW - Booking',
        index: index,
        item_brand: (operatedBy && operatedBy?.carrier) || 'G4',
        item_category: '3rd Party/Hotels',
        item_category2: hotel?.name,
        item_category3: 'D',
        item_category4: route,
        item_category5: affinityString,
        item_variant: `${item?.id}-${item?.name}`,
        price: '',
        quantity: 1,
        item_promotion_name: promo?.headlineDescription,
        item_promotion_id: promo.id,
      },
    ],
  };
};

export const trackPromoClickEvent = (
  promo,
  index,
  room,
  hotel,
  operatedBy,
  affinityString,
  route
) => {
  tracking.trackPromoSelect(
    getHotelPromoData(
      index,
      hotel,
      room,
      operatedBy,
      promo,
      affinityString,
      route
    )
  );
};

export const trackUpliftAmountClick = () => {
  tracking.trackEvent(
    'site_click_tracking',
    'Hotel',
    'Uplift Pay Monthly Message'
  );
};

export const trackUpliftLogoClick = () => {
  tracking.trackEvent('site_click_tracking', 'Hotel', 'Uplift Logo');
};
